'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/throttleTime';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {USER_COLLECTION} from '../../../auth/domain/config';
import {ORGANIZATION_COLLECTION} from '../../../organizations/domain/config';
import {PERSONNEL_COLLECTION} from '../../../personnel/domain/config';
import {PROJECT_COLLECTION} from '../../../projects/domain/ProjectDomain';
import {ASSET_COLLECTION} from '../../../assets/domain/AssetDomain';
import {ASSET_PROJECT_COLLECTION} from '../../../projects/domain/AssetProjectDomain';
import {requestLogout} from '../../../auth/actions';
import {
  assetDeleted,
  assetProjectDeleted,
  assignAssetProjectToModel,
  assignAssetToModel,
  assignOrganizationProfileToModel,
  assignOrganizationToModel,
  assignProjectToModel,
  assignUserToModel,
  organizationDeleted,
  organizationProfileDeleted,
  projectDeleted,
  userDeleted,
} from '../actions';
import {logger} from './logger';

export const epics = [
  onUserDeleted,
  onOrganizationDeleted,
  onOrganizationProfileDeleted,
  onProjectDeleted,
  onAssetDeleted,
  onAssetProjectDeleted,
];

const inject = [
  'EventBus',
  'FirebaseUtil',
];

onUserDeleted.$inject = inject;
onOrganizationDeleted.$inject = inject;
onOrganizationProfileDeleted.$inject = inject;
onProjectDeleted.$inject = inject;
onAssetDeleted.$inject = inject;
onAssetProjectDeleted.$inject = inject;

export function onUserDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    USER_COLLECTION,
    'user',
    assignUserToModel.TYPE,
    userDeleted,
    assignUserToModel,
  );
}

export function onOrganizationDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    ORGANIZATION_COLLECTION,
    'organization',
    assignOrganizationToModel.TYPE,
    organizationDeleted,
    assignOrganizationToModel,
  );
}

export function onOrganizationProfileDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    PERSONNEL_COLLECTION,
    'orgProfile',
    assignOrganizationProfileToModel.TYPE,
    organizationProfileDeleted,
    assignOrganizationProfileToModel,
  );
}

export function onProjectDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    PROJECT_COLLECTION,
    'project',
    assignProjectToModel.TYPE,
    projectDeleted,
    assignProjectToModel,
  );
}

export function onAssetDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    ASSET_COLLECTION,
    'asset',
    assignAssetToModel.TYPE,
    assetDeleted,
    assignAssetToModel,
  );
}

export function onAssetProjectDeleted(action$, store, dependencies) {
  return createWatchDeletion(
    action$,
    store,
    dependencies,
    ASSET_PROJECT_COLLECTION,
    'assetProject',
    assignAssetProjectToModel.TYPE,
    assetProjectDeleted,
    assignAssetProjectToModel,
  );
}


function createWatchDeletion(action$, store, dependencies, collection, propName, onType, deletedAction, assignAction) {
  return action$.ofType(onType)
    .map((action) => getId(action.payload[propName]))
    .distinctUntilChanged()
    .switchMap((id) => id
      ? createDeletedStream(action$, collection, id)
      : Observable.empty())
    .do(__notify.bind(null, propName))
    .switchMap((id) => Observable.from([deletedAction(id), assignAction(null)])) // dispatch 2 actions
    .catch(epicErrorHandler(logger, 'createWatchDeletion'));

  function createDeletedStream(action$, collection, id) {
    return getRef(collection, id)
      .observe('value')
      .takeUntil(action$.ofType(requestLogout.TYPE))
      .map((ss) => !ss.exists() || ss.child('isDeleting').val())
      .filter((deleted) => !!deleted)
      .distinctUntilChanged()
      .mapTo(id)
      .catch((error, source) => {
        logger.error(error);
        return Observable.timer(2500)
          .takeUntil(action$.ofType(requestLogout.TYPE))
          .switchMap(() => source);
      }); // ignore errors; likely to happen with lack of permission race-conditions;
  }

  function getRef(collection, id) {
    return dependencies.FirebaseUtil.firebaseRef(`${collection}/${id}`);
  }

  // Legacy hook
  function __notify(name) {
    logger.debug(`event:deleting:${name}`);
    dependencies.EventBus.broadcast(`event:deleting:${name}`);
  }
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/watchDeletion.js